function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Fragment as k, computed as x, defineComponent as y, h as L, inject as A, onMounted as w, onUnmounted as D, provide as j, ref as g, watchEffect as B } from "vue";
import { Features as M, render as I, omit as F } from "../../utils/render.js";
import { useId as O } from "../../hooks/use-id.js";
import { Keys as b } from "../../keyboard.js";
import { dom as P } from "../../utils/dom.js";
import { match as C } from "../../utils/match.js";
import { focusIn as T, Focus as m } from "../../utils/focus-management.js";
import { useResolveButtonType as K } from "../../hooks/use-resolve-button-type.js";
import { FocusSentinel as $ } from "../../internal/focus-sentinel.js";
let H = Symbol("TabsContext");

function h(n) {
  let u = A(H, null);

  if (u === null) {
    let i = new Error("<".concat(n, " /> is missing a parent <TabGroup /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(i, h), i;
  }

  return u;
}

let Y = y({
  name: "TabGroup",
  emits: {
    change: n => !0
  },
  props: {
    as: {
      type: [Object, String],
      default: "template"
    },
    selectedIndex: {
      type: [Number],
      default: null
    },
    defaultIndex: {
      type: [Number],
      default: 0
    },
    vertical: {
      type: [Boolean],
      default: !1
    },
    manual: {
      type: [Boolean],
      default: !1
    }
  },
  inheritAttrs: !1,

  setup(n, _ref) {
    let u = _ref.slots,
        i = _ref.attrs,
        f = _ref.emit;
    let t = g(null),
        o = g([]),
        l = g([]),
        d = {
      selectedIndex: t,
      orientation: x(() => n.vertical ? "vertical" : "horizontal"),
      activation: x(() => n.manual ? "manual" : "auto"),
      tabs: o,
      panels: l,

      setSelectedIndex(e) {
        t.value !== e && (t.value = e, f("change", e));
      },

      registerTab(e) {
        o.value.includes(e) || o.value.push(e);
      },

      unregisterTab(e) {
        let r = o.value.indexOf(e);
        r !== -1 && o.value.splice(r, 1);
      },

      registerPanel(e) {
        l.value.includes(e) || l.value.push(e);
      },

      unregisterPanel(e) {
        let r = l.value.indexOf(e);
        r !== -1 && l.value.splice(r, 1);
      }

    };
    return j(H, d), B(() => {
      var v;
      if (d.tabs.value.length <= 0 || n.selectedIndex === null && t.value !== null) return;
      let e = d.tabs.value.map(p => P(p)).filter(Boolean),
          r = e.filter(p => !p.hasAttribute("disabled")),
          s = (v = n.selectedIndex) != null ? v : n.defaultIndex;
      if (s < 0) t.value = e.indexOf(r[0]);else if (s > d.tabs.value.length) t.value = e.indexOf(r[r.length - 1]);else {
        let p = e.slice(0, s),
            a = [...e.slice(s), ...p].find(c => r.includes(c));
        if (!a) return;
        t.value = e.indexOf(a);
      }
    }), () => {
      let e = {
        selectedIndex: t.value
      };
      return L(k, [o.value.length <= 0 && L($, {
        onFocus: () => {
          for (let r of o.value) {
            let s = P(r);
            if ((s == null ? void 0 : s.tabIndex) === 0) return s.focus(), !0;
          }

          return !1;
        }
      }), I({
        props: _objectSpread(_objectSpread({}, i), F(n, ["selectedIndex", "defaultIndex", "manual", "vertical", "onChange"])),
        slot: e,
        slots: u,
        attrs: i,
        name: "TabGroup"
      })]);
    };
  }

}),
    Z = y({
  name: "TabList",
  props: {
    as: {
      type: [Object, String],
      default: "div"
    }
  },

  setup(n, _ref2) {
    let u = _ref2.attrs,
        i = _ref2.slots;
    let f = h("TabList");
    return () => {
      let t = {
        selectedIndex: f.selectedIndex.value
      },
          o = {
        role: "tablist",
        "aria-orientation": f.orientation.value
      };
      return I({
        props: _objectSpread(_objectSpread({}, n), o),
        slot: t,
        attrs: u,
        slots: i,
        name: "TabList"
      });
    };
  }

}),
    ee = y({
  name: "Tab",
  props: {
    as: {
      type: [Object, String],
      default: "button"
    },
    disabled: {
      type: [Boolean],
      default: !1
    }
  },

  setup(n, _ref3) {
    let u = _ref3.attrs,
        i = _ref3.slots,
        f = _ref3.expose;
    let t = h("Tab"),
        o = "headlessui-tabs-tab-".concat(O()),
        l = g(null);
    f({
      el: l,
      $el: l
    }), w(() => t.registerTab(l)), D(() => t.unregisterTab(l));
    let d = x(() => t.tabs.value.indexOf(l)),
        e = x(() => d.value === t.selectedIndex.value);

    function r(a) {
      let c = t.tabs.value.map(S => P(S)).filter(Boolean);

      if (a.key === b.Space || a.key === b.Enter) {
        a.preventDefault(), a.stopPropagation(), t.setSelectedIndex(d.value);
        return;
      }

      switch (a.key) {
        case b.Home:
        case b.PageUp:
          return a.preventDefault(), a.stopPropagation(), T(c, m.First);

        case b.End:
        case b.PageDown:
          return a.preventDefault(), a.stopPropagation(), T(c, m.Last);
      }

      if (C(t.orientation.value, {
        vertical() {
          if (a.key === b.ArrowUp) return T(c, m.Previous | m.WrapAround);
          if (a.key === b.ArrowDown) return T(c, m.Next | m.WrapAround);
        },

        horizontal() {
          if (a.key === b.ArrowLeft) return T(c, m.Previous | m.WrapAround);
          if (a.key === b.ArrowRight) return T(c, m.Next | m.WrapAround);
        }

      })) return a.preventDefault();
    }

    function s() {
      var a;
      (a = P(l)) == null || a.focus();
    }

    function v() {
      var a;
      n.disabled || ((a = P(l)) == null || a.focus(), t.setSelectedIndex(d.value));
    }

    function p(a) {
      a.preventDefault();
    }

    let E = K(x(() => ({
      as: n.as,
      type: u.type
    })), l);
    return () => {
      var S, R;
      let a = {
        selected: e.value
      },
          c = {
        ref: l,
        onKeydown: r,
        onFocus: t.activation.value === "manual" ? s : v,
        onMousedown: p,
        onClick: v,
        id: o,
        role: "tab",
        type: E.value,
        "aria-controls": (R = (S = t.panels.value[d.value]) == null ? void 0 : S.value) == null ? void 0 : R.id,
        "aria-selected": e.value,
        tabIndex: e.value ? 0 : -1,
        disabled: n.disabled ? !0 : void 0
      };
      return I({
        props: _objectSpread(_objectSpread({}, n), c),
        slot: a,
        attrs: u,
        slots: i,
        name: "Tab"
      });
    };
  }

}),
    te = y({
  name: "TabPanels",
  props: {
    as: {
      type: [Object, String],
      default: "div"
    }
  },

  setup(n, _ref4) {
    let u = _ref4.slots,
        i = _ref4.attrs;
    let f = h("TabPanels");
    return () => {
      let t = {
        selectedIndex: f.selectedIndex.value
      };
      return I({
        props: n,
        slot: t,
        attrs: i,
        slots: u,
        name: "TabPanels"
      });
    };
  }

}),
    ae = y({
  name: "TabPanel",
  props: {
    as: {
      type: [Object, String],
      default: "div"
    },
    static: {
      type: Boolean,
      default: !1
    },
    unmount: {
      type: Boolean,
      default: !0
    }
  },

  setup(n, _ref5) {
    let u = _ref5.attrs,
        i = _ref5.slots,
        f = _ref5.expose;
    let t = h("TabPanel"),
        o = "headlessui-tabs-panel-".concat(O()),
        l = g(null);
    f({
      el: l,
      $el: l
    }), w(() => t.registerPanel(l)), D(() => t.unregisterPanel(l));
    let d = x(() => t.panels.value.indexOf(l)),
        e = x(() => d.value === t.selectedIndex.value);
    return () => {
      var v, p;
      let r = {
        selected: e.value
      },
          s = {
        ref: l,
        id: o,
        role: "tabpanel",
        "aria-labelledby": (p = (v = t.tabs.value[d.value]) == null ? void 0 : v.value) == null ? void 0 : p.id,
        tabIndex: e.value ? 0 : -1
      };
      return I({
        props: _objectSpread(_objectSpread({}, n), s),
        slot: r,
        attrs: u,
        slots: i,
        features: M.Static | M.RenderStrategy,
        visible: e.value,
        name: "TabPanel"
      });
    };
  }

});
export { ee as Tab, Y as TabGroup, Z as TabList, ae as TabPanel, te as TabPanels };